export default __webpack_public_path__ + "static/media/biketour.875bc8fd.jpg";